/*
 * @Author: yuanxing(01407381)
 * @Date: 2023-12-19 10:30:00
 * @FilePath: \ibu-owt-core-frontend\services\apply.js
 * @Description: 在线申报接口
 */

import { coreUrl } from './api'
import { formatAsUrlParamString } from '@/utils/utils'
export default ($axios, store) => {
  return {
    // 在线清关平台-报关方式
    async queryCustomsTypesApi(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/queryCustomsTypes`,
        { params, ...config }
      )
      return res?.result
    },
    // 在线清关平台-列表数据
    async queryApplyOrderList(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/queryOrderManagementPage`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res
    },
    // 在线签署装箱单/发票  列表请求
    async querySignPackingListOrderList(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsVisa/queryList`,
        // { params, ...config }
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res
    },
    // 在线签署装箱单/发票 详情页面
    async queryDetail(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsVisa/queryDetail`,
        {
          params,
          ...config,
        }
      )
      return res
    },
    // 当签署成功状态时  获取签署文件列表
    async getSignedTableData(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsVisa/queryFile`,
        {
          params,
          ...config,
        }
      )
      return res
    },
    // 时代天使 签署接口
    async getContractUrl(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsVisa/getContractUrl`,
        {
          params,
          ...config,
        }
      )
      return res
    },
    // 时代天使 详情 提交代码
    async saveDetail(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsVisa/saveDetail`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res
    },
    async getSwitchConfig(params = {}, config = {}) {
      const res = await $axios(`${coreUrl}/customsDeclaration/getSwitchConfig`, {
        params,
        backAll: true,
        ...config,
      })
      return res
    },
    // 在线申报平台 低值判断
    async editValid(params = {}, config = {}) {
      const res = await $axios(`${coreUrl}/customsDeclaration/editValid`, {
        params,
        backAll: true,
        ...config,
      })
      return res
    },
    // 低值 选择商品信息后 调用
    async queryCommonData(params = {}, config = {}) {
      const res = await $axios(`${coreUrl}/customsDeclaration/queryCommonData`, {
        params,
        backAll: true,
        ...config,
      })
      return res
    },
    // 在线清关平台-获取订单信息
    async getOrderInfo(params = {}, config = {}) {
      const res = await $axios(`${coreUrl}/customsDeclaration/getOrderInfo`, {
        params,
        backAll: true,
        ...config,
      })
      return res
    },

    // 在线申报平台 详情页面 在线咨询 获取加密信息的接口
    async onlineCustomerEncrypt(params = {}, config = {}) {
      const res = await $axios(`${coreUrl}/customsDeclaration/onlineCustomerEncrypt`, {
        params,
        backAll: true,
        ...config,
      })
      return res
    },
    // 在线清关平台-获取清关上传单证列表和申报模板（暂时不用）
    async getCustomsTemplate(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/getCustomsUploadListAndDeclareTemplate`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res?.result
    },
    // 在线清关平台-获取清关上传单证列表和申报模板
    async getCustomsUploadAndDeclareTemplateApi(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/getCustomsUploadAndDeclareTemplate`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res?.result
    },
    // 在线清关平台-申报字段模板下拉数据
    async getCustomsCache(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/queryDeclareTemplateCache`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res?.result
    },
    // 在线清关平台-申报数据查询
    async queryCustomsData(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/queryDeclareData`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res?.result
    },

    // 在线清关平台-申报数据保存
    async saveCustomsData(urlParams = {}, params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/saveDeclareData${formatAsUrlParamString(
          urlParams
        )}`,
        {
          method: 'POST',
          data: params,
          backAll: true,
          ...config,
        }
      )
      return res
    },
    // 在线清关平台-获取清关上传单证列表（详情页）
    async getCustomsUploadListApi(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/getCustomsUploadList`,
        {
          params,
          ...config,
        }
      )
      return res?.result
    },

    // 在线清关平台-获取订单详情信息
    async getOrderDetailInfoApi(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/getOrderDetailInfo`,
        {
          params,
          backAll: true,
          ...config,
        }
      )
      return res
    },
    // 在线清关平台-商品推荐
    async queryGoodsApi(params = {}, config = {}) {
      const res = await $axios(`${coreUrl}/customsDeclaration/queryGoods`, {
        params,
        ...config,
      })
      return res?.result
    },
    // 在线清关平台-品名校验+品名要素推荐
    async queryAcceptCriteriaApi(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/acceptCriteria/checkToken/overseas/list`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res?.result
    },
    // 在线清关平台-申报订单管理查询-手机验证码
    async queryOrderManagementPageFromTelApi(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/queryOrderManagementPageFromTel`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res
    },
    // 在线清关平台-申报订单管理查询-运单号逐票
    async queryOrderManagementPageFromMailnoApi(
      urlParams = {},
      params = {},
      config = {}
    ) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/queryOrderManagementPageFromMailno`,
        {
          method: 'POST',
          params: urlParams,
          data: params,
          ...config,
        }
      )
      return res
    },
    // 在线清关平台-获取订单详情信息
    async getCanEditfieldsApi(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/queryCanEditfieldsByBno`,
        {
          method: 'POST',
          data: params,
          backAll: true,
          ...config,
        }
      )
      return res
    },
    // 提交历史
    async querySubmitLogCondition(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/querySubmitLogCondition`,
        {
          method: 'POST',
          data: params,
          ...config,
        }
      )
      return res?.result
    },
    // 列表查看数据 接口
    async getFileContentSafe(params = {}, config = {}) {
      const res = await $axios(
        // `${coreUrl}/customsDeclaration/getFileByOssName`,
        `${coreUrl}/customsDeclaration/getFileContentSafe`,
        {
          params,
          ...config,
        }
      )
      return res?.result
    },
    // 查询提交日志文件列表
    async querySubmitLogFileList(params = {}, config = {}) {
      const res = await $axios(
        `${coreUrl}/customsDeclaration/querySubmitLogFileList`,
        {
          params,
          ...config,
        }
      )
      return res?.result
    },

  }
}
